import {
  showInvalidInput
} from './utils';


const formValidate = document.querySelector('.form--validate');

showInvalid(formValidate);

function showInvalid(form) {
  if (form) {
    const buttonSubmit = form.querySelector('button[type=submit]');
    buttonSubmit.addEventListener('click', function () {
      showInvalidInput(form);
    });
  } else {
    return;
  }
}
